import { createClient } from '@/api/supabase'

/**
 * Единая лента «Активность» лида — через RPC public.get_lead_activity.
 * Бэкенд мержит все источники (создание, статусы, правки, комментарии,
 * события lead_events вкл. Автотеку, напоминания, SMS, звонки, заказ, торги
 * Carlink) в один
 * хронологический список (новые сверху). См. миграцию 20260622100000.
 */
export type LeadActivityKind =
  | 'created'
  | 'status'
  | 'field_change'
  | 'comment'
  | 'event'
  | 'reminder'
  | 'sms'
  | 'call'
  | 'call_result'
  | 'order'
  | 'auction'

export interface LeadActivityItem {
  kind: LeadActivityKind
  at: string
  actor_id: string | null
  actor_name: string | null
  meta: Record<string, unknown>
}

export async function getLeadActivity(leadId: string): Promise<LeadActivityItem[]> {
  const supabase = createClient()
  const { data, error } = await supabase.rpc('get_lead_activity', { p_lead_id: leadId })
  if (error) throw new Error(error.message)
  return (data ?? []) as LeadActivityItem[]
}
